import L from "lodash/fp";
import BaseView from "scripts/views/baseView";
import inject from "scripts/ioc/inject";
import DownloadUrlModel from "../models/downloadUrlModel";

import templateDownloadButton from "templates/downloadButton/base.hbs";

class BaseDownloadButtonView extends BaseView {
  constructor(options, connectionService = inject("connectionService"), i18nextService = inject("i18nextService")) {
    super(options);

    this.connectionService = connectionService;
    this.i18nextService = i18nextService;

    this.contentModel = options.contentModel;
    this.downloadUrlModel = new DownloadUrlModel({ contentModel: options.contentModel });
  }

  get className() {
    return "bb-download";
  }

  get template() {
    return templateDownloadButton;
  }

  sync() {
    return this.downloadUrlModel.fetch();
  }

  render() {
    const isOnline = this.connectionService.getConnectionStatus().isOnline;
    this.$el.html(
      this.template({
        i18n: this.getTranslations(),
        downloadUrl: this.downloadUrlModel.get("downloadUrl"),
      }),
    );

    const $button = this.$el.find(".bb-media-details-download-button");

    $button.addClass(this.classNames);
    $button.append(this.icon);

    this.initializeDownloadButton();

    if (this.downloadUrlModel.get("downloadUrl") !== undefined) {
      $button.removeClass("loading link-disabled");
    }

    if (!isOnline) {
      $button.addClass("link-disabled");
    }

    return this;
  }

  getTranslations() {
    const attributes = this.i18nextService.getAttributes();
    const dataOriginalTitle = L.flowRight(L.pick(["download"]), L.get(["data", "originalTitle"]))(attributes);
    return {
      download: {
        ariaLabel: attributes.ariaLabel.downloadName(this.contentModel.get("name")),
        title: attributes.ariaLabel.download,
        dataOriginalTitle,
      },
    };
  }

  initializeDownloadButton() {
    const isOnline = this.connectionService.getConnectionStatus().isOnline;
    const isCompound = this.contentModel.get("mimeType") === "application/biblioboard+compound_content";
    const contentAllowDownload = this.contentModel.get("allowDownload") && !isCompound;

    if (process.env.PATRON_UI_PREVENT_FILE_DOWNLOAD !== "true" && contentAllowDownload) {
      this.showDownloadButton();
    } else {
      this.hideDownloadButton();
    }

    if (isOnline) {
      this.enableDownloadButton();
    } else {
      this.disableDownloadButton();
    }
  }

  showDownloadButton() {
    this.$el.removeClass("hide");
  }

  hideDownloadButton() {
    this.$el.addClass("hide");
  }

  enableDownloadButton() {
    this.$el.find(".bb-media-details-download-button").removeClass("link-disabled");
  }

  disableDownloadButton() {
    this.$el.find(".bb-media-details-download-button").addClass("link-disabled");
  }
}
export default BaseDownloadButtonView;
